import { Platform } from 'helpers/platform';
import get from 'lodash/get';
import { addNotificationHandler } from 'store/middleware/displayNotification';
import { studentSelector } from '@lingoda/students';

void addNotificationHandler({
    check: (state) => {
        const student = studentSelector(state);

        if (student && get(student, 'preferences.npsFeedbackRequired')) {
            return { type: 'recommend' };
        }
    },
    once: true,
    platforms: [Platform.SBE],
});
